module.exports = {
    cognitoUserPoolClientId: '4unvbsvtmoo1r0f5mhbc51ucd5',
    cognitoUserPoolId: 'us-east-1_Pjr0Q95Dl',
    environment: 'test',
    lowerEnvironment: '',
    restApiEndpoint: 'https://qrrby41pa1.execute-api.us-east-1.amazonaws.com/test',
    restApiName: 'test-dsco-ship-codes-ApiStack-JH6VANTANU77'
}
